import React from 'react';
import { Link } from 'react-router-dom';
import arrowLeft from 'assets/arrow_left.svg';
import arrowRight from 'assets/arrow_right.svg';
import reverse from 'lodash/reverse';

type CrumbProps = {
  name: string;
  path: string;
};

type BreadcrumbsProps = {
  crumbs: CrumbProps[];
  integrationName: string;
  translate: (key: string) => string;
};

const Breadcrumbs = ({ crumbs, integrationName, translate }: BreadcrumbsProps) => {
  const renderCrumbs: React.ReactNode[] = [];

  crumbs.forEach(({ name, path }: CrumbProps, key: number) => {
    const translatedName =
      name === 'Integrations' ? translate('Integrations.int') : translate(name);

    if (key === 0 && crumbs.length <= 1) {
      renderCrumbs.push(<span key={name}>{translatedName}</span>);
    }

    if (key === 0 && path.includes('integrations') && crumbs.length === 2) {
      const translatedIntegrationName = translate(integrationName);
      renderCrumbs.push(<span key={name}>{translatedIntegrationName}</span>);
    }

    if (key === 0 && path.includes('integrations') && crumbs.length > 2) {
      const translatedIntegrations = translate('Integration.int');
      renderCrumbs.push(
        <div className="flex flex-row" key={name}>
          <img className="flex pr-10" src={arrowLeft} alt="arrow pointing left icon" />
          <Link to={'/integrations'}>{translatedIntegrations}</Link>
        </div>,
      );
    }

    if (key !== 0 && crumbs.length <= 2) {
      renderCrumbs.push(
        <div className="flex flex-row" key={name}>
          <img className="flex ml-30 pr-10" src={arrowLeft} alt="arrow pointing left icon" />
          <Link to={path}>{translatedName}</Link>
          <img className="flex ml-20 mr-15" src={arrowRight} alt="arrow pointing right icon" />
        </div>,
      );
    }
  });
  const reversed = reverse(renderCrumbs);
  return <>{reversed}</>;
};

export default Breadcrumbs;
